module.exports = __webpack_public_path__ + "res/fontawesome-webfont.svg?912ec66d7572ff821749319396470bde";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 220
// module chunks = 0